import { MOCKEND_ALL_DISABLED, MOCKEND_TIMING } from "src/config";
import getIdToken from "./mocks/getIdToken.json";
import getDossier from "./mocks/getDossier.json";
import getDossierConfiguration from "./mocks/getDossierConfiguration.json";
import postPolicy from "./mocks/postPolicy.json";
import putPolicy from "./mocks/putPolicy.json";
import getCookie from "./mocks/getCookie.json";
import postEvaluatePremium from "./mocks/postEvaluatePremium.json";
import getQuestionnaire from "./mocks/getQuestionnaire.json";
import postQuestionnaire from "./mocks/postQuestionnaire.json";
import { MockendConfig } from "src/types";
import postGetGroup from "./mocks/postGetGroup.json";
import getProvinces from "./mocks/getProvinces.json";
import getMunicipalities from "./mocks/getMunicipalities.json";
import getCap from "./mocks/getCap.json"; 
import postCreateCheckout from "./mocks/postCreateCheckout.json";
import getCheckoutDetails from "./mocks/getCheckoutDetails.json";

export const ALL_DISABLED = MOCKEND_ALL_DISABLED;
export const ALL_ENABLED = true;
export const TIMING = MOCKEND_TIMING;

export const CONFIG: MockendConfig = {
  getIdToken: {
    enabled: false,
    status: 200,
    mocks: {
      200: getIdToken,
    },
  },
  getDossier: {
    enabled: false,
    status: 200,
    mocks: {
      200: getDossier,
    },
  },
  getDossierConfiguration: {
    enabled: false,
    status: 200,
    mocks: {
      200: getDossierConfiguration,
    },
  },
  postPolicy: {
    enabled: false,
    status: 200,
    mocks: {
      200: postPolicy,
    },
  },
  putPolicy: {
    enabled: false,
    status: 200,
    mocks: {
      200: putPolicy,
    },
  },
  getCookie: {
    enabled: false,
    status: 200,
    mocks: {
      200: getCookie,
    },
  },
  postEvaluatePremium: {
    enabled: false,
    status: 200,
    mocks: {
      200: postEvaluatePremium,
    },
  },
  getQuestionnaire: {
    enabled: false,
    status: 200,
    mocks: {
      200: getQuestionnaire,
    },
  },
  postQuestionnaire: {
    enabled: false,
    status: 200,
    mocks: {
      200: postQuestionnaire,
    },
  },
  postGetGroup: {
    enabled: false,
    status: 200,
    mocks: {
      200: postGetGroup,
    },
  },
  getProvinces: {
    enabled: false,
    status: 200,
    mocks: {
      200: getProvinces,
    },
  },
  getMunicipalities: {
    enabled: false,
    status: 200,
    mocks: {
      200: getMunicipalities,
    },
  },
  getCap: {
    enabled: false,
    status: 200,
    mocks: {
      200: getCap,
    },
  },
  postCreateCheckout: {
    enabled: false,
    status: 200,
    mocks: {
      200: postCreateCheckout,
    },
  },
  getCheckoutDetails: {
    enabled: false,
    status: 200,
    mocks: {
      200: getCheckoutDetails,
    },
  },
};
